import { render, staticRenderFns } from "./allMenusOld.vue?vue&type=template&id=0e4cafcc&scoped=true"
import script from "./allMenusOld.vue?vue&type=script&lang=js"
export * from "./allMenusOld.vue?vue&type=script&lang=js"
import style0 from "./allMenusOld.vue?vue&type=style&index=0&id=0e4cafcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4cafcc",
  null
  
)

export default component.exports